import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Resource } from '../../domain/dtos/groups'
import { GeneralError } from '../../domain/errors/general'
import { Envs } from '../../envs'

export class GetAvailableResources {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(): Promise<Resource[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/resource/getAllResources/pt`,
      body: { data: null },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result.resources
    }

    throw new GeneralError()
  }
}
